import React, { useState, useRef, useEffect } from "react";
import { useInterval } from "./useInterval";
import {
  CANVAS_SIZE,
  SNAKE_START,
  APPLE_START,
  SCALE,
  SPEED,
  DIRECTIONS,
} from "./constants";

const Snake = ({ scoreSnake }) => {
  const canvasRef = useRef();
  const [snake, setSnake] = useState(SNAKE_START);
  const [apple, setApple] = useState(APPLE_START);
  const [dir, setDir] = useState([0, -1]);
  const [speed, setSpeed] = useState(null);
  const [gameOver, setGameOver] = useState(false);
  const [hideStartBtn, setHideStartBtn] = useState(false);

  useInterval(() => gameLoop(), speed);

  const endGame = () => {
    setSpeed(null);
    setGameOver(true);
    setHideStartBtn(false);
  };

  const moveSnake = ({ keyCode }) =>
    keyCode >= 37 && keyCode <= 40 && setDir(DIRECTIONS[keyCode]);

  const createApple = () =>
    apple.map((_a, i) => Math.floor(Math.random() * (CANVAS_SIZE[i] / SCALE)));

  const checkCollision = (piece, snk = snake) => {
    if (
      piece[0] * SCALE >= CANVAS_SIZE[0] ||
      piece[0] < 0 ||
      piece[1] * SCALE >= CANVAS_SIZE[1] ||
      piece[1] < 0
    )
      return true;

    for (const segment of snk) {
      if (piece[0] === segment[0] && piece[1] === segment[1]) return true;
    }
    return false;
  };

  const checkAppleCollision = (newSnake) => {
    if (newSnake[0][0] === apple[0] && newSnake[0][1] === apple[1]) {
      let newApple = createApple();
      while (checkCollision(newApple, newSnake)) {
        newApple = createApple();
      }
      setApple(newApple);
      return true;
    }
    return false;
  };

  const gameLoop = () => {
    const snakeCopy = JSON.parse(JSON.stringify(snake));
    const newSnakeHead = [snakeCopy[0][0] + dir[0], snakeCopy[0][1] + dir[1]];
    snakeCopy.unshift(newSnakeHead);
    if (checkCollision(newSnakeHead)) endGame();
    if (!checkAppleCollision(snakeCopy)) snakeCopy.pop();
    setSnake(snakeCopy);
  };

  const startGame = () => {
    setSnake(SNAKE_START);
    setApple(APPLE_START);
    setDir([0, -1]);
    setSpeed(SPEED);
    setGameOver(false);
    setHideStartBtn(true);
  };

  useEffect(() => {
    canvasRef.current.focus();
    const context = canvasRef.current.getContext("2d");
    context.setTransform(SCALE, 0, 0, SCALE, 0, 0);
    context.clearRect(0, 0, window.innerWidth, window.innerHeight);
    context.fillStyle = "#7DD4FF"; // Serpiente
    snake.forEach(([x, y]) => context.fillRect(x, y, 1, 1));
    context.fillStyle = "#8F00FF"; // Manzana
    context.fillRect(apple[0], apple[1], 1, 1);
  }, [snake, apple, gameOver]);

  // ✅ Mover setState del padre fuera del render
  useEffect(() => {
    if (typeof scoreSnake === "function") {
      scoreSnake(snake.length - 2);
    }
  }, [snake, scoreSnake]);

  return (
    <div tabIndex="0" onKeyDown={(e) => moveSnake(e)} className="relative">
      <canvas
        className="bg-[#010C15] border border-[#1E2D3D] rounded-lg"
        ref={canvasRef}
        width={`${CANVAS_SIZE[0]}px`}
        height={`${CANVAS_SIZE[1]}px`}
      />
      {gameOver && (
        <div className="absolute bottom-24 left-1/2 -translate-x-1/2 text-[#7DD4FF] py-3 w-full rounded-lg text-center text-2xl bg-[#011627]/[84%] inner-shadow-snake transition-all">
          ¡GAME OVER 💀!
        </div>
      )}
      <button
        onClick={startGame}
        className={`absolute text-white text-sm bottom-10 left-1/2 -translate-x-1/2 bg-[#8A3BFF] py-2.5 px-[14px] rounded-lg transition-all ${
          hideStartBtn ? "opacity-0 cursor-default" : ""
        }`}
      >
        Comenzar
      </button>
    </div>
  );
};

export default Snake;
